import { render, staticRenderFns } from "./Invitess.vue?vue&type=template&id=39db0857&scoped=true"
import script from "./Invitess.vue?vue&type=script&lang=js"
export * from "./Invitess.vue?vue&type=script&lang=js"
import style0 from "./Invitess.vue?vue&type=style&index=0&id=39db0857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db0857",
  null
  
)

export default component.exports